export default function CompletedCounter({ challengeData }) {
  const { completedCount } = challengeData;

  return (
    !!completedCount && (
      <div className={'challenges__section-completed-counter task__item-completed-counter'}>{completedCount}</div>
    )
  );
}
